export class SyncProgressEvent {
  constructor(public title: string, public total: number, public progress: number, public isError: boolean = false) {}
}
